import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Specializare, SpecializareUpdate } from './specializari.interface';

@Injectable({
    providedIn: 'root'
})
export class SpecializariService {
    private basePath = environment.interop.basePath;

    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.delete;
    private listActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.listActive;
    private listPublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.listPublic;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.specializari.updatePublic;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.get(this.listUrl);
    }

    add(specializare: Specializare) {
        return this.http.post(this.storeUrl, specializare);
    }

    update(specializare: SpecializareUpdate) {
        return this.http.put(this.updateUrl, specializare);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    listActive() {
        return this.http.get(this.listActiveUrl);
    }

    listPublic() {
        return this.http.get(this.listPublicUrl);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }
}
